import React, { useState } from "react";
import { useField, useFormikContext } from "formik";
import { TFormValues } from "../../types";
import {
  yesNo,
  states,
  AboriginalOrTorresStrait,
  Concerns,
  Outcomes,
  applyingOnBehalfOf,
  partyType,
  tellUsMoreOptions,
  yesNoUnsure
} from "../../config/questionOptions";

import { GuideContext } from "../../../../components/GatewayForm/GatewayForm.store";

import Button from "../../../Button/Button";
import { AccordionItem, Accordion } from "../../../Accordion/Accordion";

// TODO: Fill out with Proper Content from Form

const SummaryItem = ({
  question,
  answer,
}: {
  question?: string;
  answer?: string;
}) => {
  return (
    <div
      style={{
        marginTop: "26px",
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        flexWrap: "wrap",
      }}
    >
      <p style={{ fontWeight: "bold", maxWidth: "177px" }}>{question}</p>
      <p style={{ width: "270px" }}>{answer}</p>
    </div>
  );
};

const EligibleReview: React.FC<{}> = () => {
  const { setCurrentStep } = React.useContext(GuideContext);
  const { values } = useFormikContext<TFormValues>();

  const reviewSections = [];

  return (
    <Accordion>
      <AccordionItem heading="Step 1: Location">
        <SummaryItem
          question="Where is the concern occurring?"
          answer={
            states.find((state) => state.value === values.location)?.label
          }
        />
        <Button
          style={{ maxWidth: "max-content", marginTop: "26px" }}
          text="Edit this step"
          variant="secondary"
          onClick={() => {
            setCurrentStep("legal-step-two");
          }}
        />
      </AccordionItem>
      <AccordionItem heading="Step 2: About you">
        <SummaryItem
          question="Do you need an interpreter?"
          answer={
            yesNo.find((option) => option.value === values.languageOtherThanEng)
              ?.label
          }
        />
        {values.languageOtherThanEng === "yes" && (
          <SummaryItem
            question="Please specify your preferred language"
            answer={values.language}
          />
        )}
        <SummaryItem
          question="Do you identify as a First Nations person?"
          answer={
            AboriginalOrTorresStrait.find(
              (option) => option.value === values.aboriginalOrTorresStrait
            )?.label
          }
        />
        <Button
          style={{ maxWidth: "max-content", marginTop: "26px" }}
          text="Edit this step"
          variant="secondary"
          onClick={() => {
            setCurrentStep("legal-step-three");
          }}
        />
      </AccordionItem>
      <AccordionItem heading="Step 3: Main concern">
        <SummaryItem
          question="How would you describe your main concern?"
          answer={
            Concerns.find((option) => option.value === values.concern)?.label
          }
        />
        <Button
          style={{ maxWidth: "max-content", marginTop: "26px" }}
          text="Edit this step"
          variant="secondary"
          onClick={() => {
            setCurrentStep("legal-step-five");
          }}
        />
      </AccordionItem>
      <AccordionItem heading="Step 3: Outcome">
        <SummaryItem
          question="What outcome would you like to achieve?"
          answer={values.outcomes.map(
            (outcome, index) =>
              `${index > 0 ? ", " : ""}${
                Outcomes.find((option) => option.value === outcome)?.label
              }`
          )}
        />
        <Button
          style={{ maxWidth: "max-content", marginTop: "26px" }}
          text="Edit this step"
          variant="secondary"
          onClick={() => {
            setCurrentStep("legal-step-six");
          }}
        />
      </AccordionItem>
      <AccordionItem heading="Concern description">
        <SummaryItem
          question="Describe your concern in more detail"
          answer={values.concernDescription}
        />
        <Button
          style={{ maxWidth: "max-content", marginTop: "26px" }}
          text="Edit this step"
          variant="secondary"
          onClick={() => {
            setCurrentStep("eligible-step-two");
          }}
        />
      </AccordionItem>
      <AccordionItem heading="Time sensitive">
        <SummaryItem
          question="Is this matter time-sensitive, or is there a deadline?"
          answer={
            yesNoUnsure.find((option) => option.value === values.timeSensitive)?.label
          }
        />
        {values.timeSensitive === "yes" && (
          <SummaryItem
            question="When is the deadline?"
            answer={new Date(values.timeSensitiveDate).toLocaleDateString(
              "en-AU"
            )}
          />
        )}
        <Button
          style={{ maxWidth: "max-content", marginTop: "26px" }}
          text="Edit this step"
          variant="secondary"
          onClick={() => {
            setCurrentStep("eligible-step-three");
          }}
        />
      </AccordionItem>
      <AccordionItem heading="Other party">
        <SummaryItem
          question="Is there another party involved?"
          answer={
            yesNoUnsure.find((option) => option.value === values.otherPartyInvolved)
              ?.label
          }
        />
        {values.otherPartyInvolved === "yes" && (
          <SummaryItem
            question="Who is the other party?"
            answer={
              partyType.find(
                (option) => option.value === values.otherPartyInvolvedType
              )?.label
            }
          />
        )}
        {values.otherPartyInvolved === "yes" && (
          <SummaryItem
            question="Full name/name of company, council, department"
            answer={values.otherPartyName}
          />
        )}
        {values.otherPartyInvolved === "yes" && values.otherPartyAddress ? (
          <SummaryItem
            question="Street address (if known)"
            answer={values.otherPartyAddress?.label}
          />
        ) : null}
        <Button
          style={{ maxWidth: "max-content", marginTop: "26px" }}
          text="Edit this step"
          variant="secondary"
          onClick={() => {
            setCurrentStep("eligible-step-four");
          }}
        />
      </AccordionItem>
      <AccordionItem heading="Applying on behalf">
        <SummaryItem
          question="Are you applying on behalf of a group or incorporated association?"
          answer={
            yesNo.find((option) => option.value === values.applyingOnBehalf)
              ?.label
          }
        />
        {values.applyingOnBehalf === "yes" && (
          <SummaryItem
            question="What kind of group or incorporated association?"
            answer={
              applyingOnBehalfOf.find(
                (option) => option.value === values.applyingOnBehalfGroupType
              )?.label
            }
          />
        )}
        {values.applyingOnBehalf === "yes" && (
          <SummaryItem
            question="Name of community group/incorporated association"
            answer={values.applyingOnBehalfName}
          />
        )}
        {values.applyingOnBehalf === "yes" && (
          <SummaryItem
            question="Main purpose (This may be found in your goals and objectives document)"
            answer={values.applyingOnBehalfPurpose}
          />
        )}
        <Button
          style={{ maxWidth: "max-content", marginTop: "26px" }}
          text="Edit this step"
          variant="secondary"
          onClick={() => {
            setCurrentStep("eligible-step-five");
          }}
        />
      </AccordionItem>
      {values.applyingOnBehalf === "no" && (
        <AccordionItem heading="More about you">
          <SummaryItem
            question="Do any of the following apply to you?"
            answer={values.tellUsMore.map(
              (item, index) =>
                `${index > 0 ? ", " : ""}${
                  tellUsMoreOptions.find((option) => option.value === item)
                    ?.label
                }`
            )}
          />
          <Button
            style={{ maxWidth: "max-content", marginTop: "26px" }}
            text="Edit this step"
            variant="secondary"
            onClick={() => {
              setCurrentStep("eligible-step-six");
            }}
          />
        </AccordionItem>
      )}
      <AccordionItem heading="Contact details">
        <SummaryItem question="Given name" answer={values.contactFirstName} />
        <SummaryItem question="Family name" answer={values.contactLastName} />
        <SummaryItem question="Email" answer={values.contactEmail} />
        <SummaryItem
          question="Date of birth"
          answer={new Date(values.contactBirthDate).toLocaleDateString("en-AU")}
        />
        <SummaryItem question="Contact Number" answer={values.contactNumber} />
        {values.contactAddress ? (
          <SummaryItem
            question="Street address"
            answer={values.contactAddress?.label}
          />
        ) : null}
        <Button
          style={{ maxWidth: "max-content", marginTop: "26px" }}
          text="Edit this step"
          variant="secondary"
          onClick={() => {
            if (values.applyingOnBehalf === "yes") {
              setCurrentStep("eligible-step-seven-two");
            } else setCurrentStep("eligible-step-seven");
          }}
        />
      </AccordionItem>
    </Accordion>
  );
};
export default EligibleReview;
